import { render, staticRenderFns } from "./AccountSubscriptions.vue?vue&type=template&id=53e62db4&scoped=true"
import script from "./AccountSubscriptions.vue?vue&type=script&lang=js"
export * from "./AccountSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e62db4",
  null
  
)

export default component.exports